import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const WorktopSection = ({ 
  worktopConfig, 
  onWorktopConfigChange, 
  errors = {},
  isCollapsed = false,
  onToggleCollapse 
}) => {
  const handleInputChange = (field, value) => {
    onWorktopConfigChange({
      ...worktopConfig,
      [field]: value
    });
  };

  const worktopTypeOptions = [
    { value: 'macif', label: 'Macif' },
    { value: 'compact', label: 'Compact' },
    { value: 'laminate', label: 'Stratifié' }
  ];

  const installationShapeOptions = [
    { value: 'simple', label: 'Simple' },
    { value: 'l-shape', label: 'Forme L' },
    { value: 'u-shape', label: 'Forme U' }
  ];

  return (
    <div className="bg-surface border border-border rounded-lg">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer"
        onClick={onToggleCollapse}
      >
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-8 h-8 bg-secondary rounded-full">
            <Icon name="Square" size={16} color="white" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-text-primary">Plan de Travail</h3>
            <p className="text-sm text-text-secondary">Type et configuration du plan de travail</p>
          </div>
        </div>
        <Icon 
          name={isCollapsed ? "ChevronDown" : "ChevronUp"} 
          size={20} 
          className="text-text-secondary" 
        />
      </div>
      {!isCollapsed && (
        <div className="px-4 pb-4 border-t border-border">
          <div className="space-y-4 mt-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Select
                label="Type de plan de travail *"
                placeholder="Sélectionner le type"
                options={worktopTypeOptions}
                value={worktopConfig?.type || ''}
                onChange={(value) => handleInputChange('type', value)}
                error={errors?.type}
                required
              />
              
              <Select
                label="Configuration d'installation *"
                placeholder="Sélectionner la forme"
                options={installationShapeOptions}
                value={worktopConfig?.installationShape || ''}
                onChange={(value) => handleInputChange('installationShape', value)}
                error={errors?.installationShape}
                required
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Input
                label="Nombre de découpes"
                type="number"
                placeholder="0"
                min="0"
                value={worktopConfig?.cutouts || ''}
                onChange={(e) => handleInputChange('cutouts', parseInt(e?.target?.value) || 0)}
                error={errors?.cutouts}
              />
            </div>

            <div className="space-y-3">
              <h4 className="text-sm font-medium text-text-primary">Intégrations</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <Checkbox
                  label="Intégration plaque de cuisson"
                  checked={worktopConfig?.cooktopIntegration || false}
                  onChange={(e) => handleInputChange('cooktopIntegration', e?.target?.checked)}
                />
                
                <Checkbox
                  label="Intégration évier et robinetterie"
                  checked={worktopConfig?.sinkIntegration || false}
                  onChange={(e) => handleInputChange('sinkIntegration', e?.target?.checked)}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorktopSection;